import React from 'react'

import CatalogueBrandSearchDatalist from './catalogue-brand-search-datalist';

const CatalogueBrandSearch = ({list, filter, filterName, updateFilters}) => {

  const handleSubmit = event => {
    event.preventDefault();

    const {value} = event.target[0];

    if (list.indexOf(value) > -1) {
      updateFilters(value);
    }
  };

  return (
    <div className="sidebar__brand">
      <h3>Бренд</h3>
      <form className="brand-search" onSubmit={handleSubmit}>
        <CatalogueBrandSearchDatalist list={list}
                                      filter={filter}/>
        <input type="submit" name="" value="" className="submit"/>
      </form>
    </div>
  )
};

export default CatalogueBrandSearch
